<template>
  <div class="content">
    <div class="top">
      <div class="el-steps-box">
        <el-steps :active="1" finish-status="success" simple>
          <el-step :title=ApplicationSelection></el-step>
          <el-step :title=AppLoadconditions></el-step>
          <el-step :title=ReducerLoadconditions></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <!-- 内容页 -->
    <div class="appPic">
      <img src="../../../../static/appPic/app07.png" alt="">
    </div>
    <h3 class="appPic_title">{{$t('message.chuandong_1')}}</h3>
    <el-tabs class="app_item" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label=loadCondition name="first">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="app_item_form">
          <el-form-item :label=chuandong_2 prop="d1">
            <span class="first_span">d1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d1" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=chuandong_3 prop="d2">
            <span class="first_span">d2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d2" auto-complete="off"></el-input>
            <span>(m)</span>
          </el-form-item>
          <el-form-item :label=chuandong_4 prop="Jp1">
            <span class="first_span">Jp1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Jp1" auto-complete="off"></el-input>
            <span>(Kgm^2)</span>
          </el-form-item>
          <el-form-item :label=chuandong_5 prop="Jp2">
            <span class="first_span">Jp2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Jp2" auto-complete="off"></el-input>
            <span>(Kgm^2)</span>
          </el-form-item>
          <el-form-item :label=chuandong_6 prop="B">
            <span class="first_span">β</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.B" auto-complete="off"></el-input>
            <span>(°)</span>
          </el-form-item>
          <el-form-item :label=chuandong_7 prop="Tp">
            <span class="first_span">Tp</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.Tp" auto-complete="off"></el-input>
            <span>(Nm)</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label=Operationmode name="second">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" class="app_item_form">
          <el-form-item :label=zhuantai_12 prop="t1">
            <span class="first_span">t1</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t1" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_13 prop="t2">
            <span class="first_span">t2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t2" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_14 prop="t3">
            <span class="first_span">t3</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t3" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_15 prop="t4">
            <span class="first_span">t4</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.t4" auto-complete="off"></el-input>
            <span>(sec)</span>
          </el-form-item>
          <el-form-item :label=zhuantai_16 prop="n2">
            <span class="first_span">n2</span>
            <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.n2" auto-complete="off"></el-input>
            <span>(r/min)</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 按钮 -->
    <div class="button_box">
      <span class="button" @click="renturnPrePage">{{$t('message.Return')}}</span>
      <span class="button" @click="toNextPage">{{$t('message.Next')}}</span>
    </div>
  </div>
</template>
<script>
  import {
    transGearRotation
  } from '@/store/electric_app'
  export default {
    name: 'SelectedGearRotation',
    data() {
      return {
        activeName: 'first',
        form: {
          d1:'',
          d2:'',
          Jp1:'',
          Jp2:'',
          B:'',
          Tp:'',
          t1:'',
          t2:'',
          t3:'',
          t4:'',
          n2:''
        },
        rules: {
          d1:[
            {required: true, message:'此项不能为空'},

          ],
          d2:[
            {required: true, message:'此项不能为空'},

          ],
          Jp1:[
            {required: true, message:'此项不能为空'},

          ],
          Jp2:[
            {required: true, message:'此项不能为空'},

          ],
          B:[
            {required: true, message:'此项不能为空'},

          ],
          Tp:[
            {required: true, message:'此项不能为空'},

          ],
          t1:[
            {required: true, message:'此项不能为空'},

          ],
          t2:[
            {required: true, message:'此项不能为空'},

          ],
          t3:[
            {required: true, message:'此项不能为空'},

          ],
          t4:[
            {required: true, message:'此项不能为空'},

          ],
          n2:[
            {required: true, message:'此项不能为空'},

          ]
        },
        ApplicationSelection:this.$t('message.ApplicationSelection'),
        AppLoadconditions:this.$t('message.AppLoadconditions'),
        ReducerLoadconditions:this.$t('message.ReducerLoadconditions'),
        reducerSize:this.$t('message.reducerSize'),
        selectMotor:this.$t('message.selectMotor'),
        complete:this.$t('message.complete'),
        loadCondition:this.$t('message.loadCondition'),
        Operationmode:this.$t('message.Operationmode'),
        chuandong_1:this.$t('message.chuandong_1'),
        chuandong_2:this.$t('message.chuandong_2'),
        chuandong_3:this.$t('message.chuandong_3'),
        chuandong_4:this.$t('message.chuandong_4'),
        chuandong_5:this.$t('message.chuandong_5'),
        chuandong_6:this.$t('message.chuandong_6'),
        chuandong_7:this.$t('message.chuandong_7'),
        zhuantai_12:this.$t('message.zhuantai_12'),
        zhuantai_13:this.$t('message.zhuantai_13'),
        zhuantai_14:this.$t('message.zhuantai_14'),
        zhuantai_15:this.$t('message.zhuantai_15'),
        zhuantai_16:this.$t('message.zhuantai_16'),
      };
    },
    methods: {
      toNextPage:function(){
        if(this.form.t1 == '' && this.form.t2 == '' && this.form.t3 == '' && this.form.t4 == '' && this.form.n2 == ''){
          this.$message({
            message: '请检查 减速机负载 与 运转模式 是否都已填写!!',
            type: 'warning'
          });
        }else{
          transGearRotation(this.form).then((response)=>{
            if(response.success === true){
              this.$emit("listenParam",response.data)
              this.$emit("listenPageChange","to_ReducerLoadPage")
              sessionStorage.setItem('childPageName','to_GearRotationPage')
            }else{
              this.$message({
                message: '齿轮参数各项不能为空!',
                type: 'warning'
              });
            }
          })
        }
      },
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_AppPage")
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    padding-bottom:20px;
    background-image: url('../../../../static/load02.png');
    background-repeat:no-repeat;
    background-position-x:right 100px;
    background-position-y:390px;
  }
  @media screen and (-webkit-min-device-pixel-ratio:0){
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:90%;
      background-position-y:390px;
    }
  }
  .top {
    height:120px;
    border-bottom:1px solid #EBEBEB;
  }
  .el-steps-box {
    width:90%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../../static/step.png') no-repeat #F5F7FA;
    background-size:18% 100%;
    background-position-x:24%;
  }
  .el-tabs {
    width:66%;
    margin:0 auto;
    margin-top:50px;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    background:#142479;
    color:#C6C6C6;
    text-align: center;
    line-height: 42px;
    border-radius: 10px;
    margin-left:15px;
    cursor: pointer;
  }
  .button_box {
    width:100%;
    text-align: center;
    padding-top:20px;
  }
  .app_item{
    margin-left:130px;
  }
  .app_item_form{
    margin-left:100px;
    margin-top:30px;
  }
  .app_item_form .el-input{
    width:60%;
    padding-left:30px;
  }
  .app_item_form .first_span{
    padding-left:50px;
    width:10px;
    display:inline-block;
  }
  .appPic {
    width:100%;
    margin:0 auto;
  }
  .appPic img {
    width:20%;
    height:20%;
    display:block;
    margin:0 auto;
    margin-top:20px;
  }
  .appPic_title {
    width:200px;
    margin:0 auto;
    text-align: center;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .app_item_form{
      margin-top:30px;
      margin-left:20px;
    }
    .app_item {
      margin-left:60px;
    }
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      padding-bottom:20px;
      background-image: url('../../../../static/load02.png');
      background-repeat:no-repeat;
      background-position-x:right 60px;
      background-position-y:340px;
    }
    @media screen and (-webkit-min-device-pixel-ratio:0){
      .content {
        width:100%;
        height: 100%;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 15px rgb(224, 224, 224);
        padding-bottom:20px;
        background-image: url('../../../../static/load02.png');
        background-repeat:no-repeat;
        background-position-x:92%;
        background-position-y:340px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/SelectedAppLoad/SelectedGearRotation.vue